var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.8 73.7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6 9.9h-5.2V5.3H12.9c.4.2.6.3.8.5 4 2.3 8 4.6 12 6.8 1.3.6 2.1 1.9 2 3.4v39.8h18.7v-6.4h5.2c0 .3.1.5.1.7v8c0 2-1 3-3 3h-21v9.7c.1 1.5-.9 2.7-2.4 2.9-.6.1-1.3-.1-1.8-.5l-21-12c-.4-.2-.8-.3-1.1-.6-.9-.5-1.4-1.5-1.4-2.5v-55C0 1 1 0 3.1 0h45.4c2.1 0 3.1 1 3.1 3.1v6.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7 19.3c.1-.7-.3-1.4-.9-1.7-.6-.3-1.3-.2-1.8.3-4.7 3.4-9.4 6.8-14 10.2-1.3.9-1.3 2 0 2.9l14 10.2c.5.5 1.2.6 1.8.2.6-.3.9-1 .9-1.6v-6.6h13.6c2 .2 3.8-1.4 4-3.4s-1.4-3.8-3.4-4H51.7v-6.5z"
  })));
}
export default SvgLogin;